import '../sass/app.scss'
import '../sass/paths/calculator.scss'
import lozad from 'lozad'
// import Swiper from 'swiper';
// import {Navigation, Pagination, Autoplay} from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import Inputmask from 'inputmask';


document.addEventListener('DOMContentLoaded', () => {

    const observer = lozad();
    observer.observe();
    let body = document.querySelector('body');
    let burger = document.querySelector('.header__burger');
    let nav = document.querySelector('.header__nav');
    burger.addEventListener('click', function () {
        burger.classList.toggle('active');
        nav.classList.toggle('active');
        body.classList.toggle('lock');
    });


    const currentLang = document.querySelector('.current-lang');
    const langSwitcher = document.querySelector('.lang-switcher');

    if (currentLang && langSwitcher) {
        currentLang.addEventListener('click', function () {
            langSwitcher.classList.toggle('open');
        });

        document.addEventListener('click', function (e) {
            if (!e.target.closest('.current-lang')) {
                langSwitcher.classList.remove('open');
            }
        });
    }

    let header = document.querySelector('.header');

    window.addEventListener('scroll', function () {
        if (window.scrollY > 0) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    });

    let getSupport = document.querySelector('.subscription__btn');
    let supportPopup = document.querySelector('.support-popup');
    let closeSupport = document.querySelector('.support-popup__close');
    let supportPopupForm = document.querySelector('.support-popup__form');
    let successPopup = document.querySelector('.success-popup');
    let successPopupClose = document.querySelector('.success-popup__btn');

    if (successPopupClose) {
        successPopupClose.addEventListener('click', function () {
            successPopup.classList.remove('visible');
        });
    }

    if (getSupport) {
        supportPopupForm.addEventListener('submit', function (e) {
            e.preventDefault();

            let formData = new FormData(supportPopupForm);

            fetch(document.querySelector('body').dataset.ajax, {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        console.log('Данные успешно отправлены:', data);
                    } else {
                        console.error('Ошибка при отправке данных:', data);
                    }
                })
                .catch(error => {
                    console.log(error);
                    console.error('Произошла ошибка:', error);
                });
            supportPopup.classList.remove('visible');
            successPopup.classList.add('visible');

            supportPopupForm.reset();
            setTimeout(() => {
                successPopup.classList.remove('visible');
            }, 3000);

        })
    }


    if (getSupport) {
        getSupport.addEventListener('click', function (e) {
            e.preventDefault();
            supportPopup.classList.add('visible');
        });
    }
    if (closeSupport) {
        closeSupport.addEventListener('click', function () {
            supportPopup.classList.remove('visible');
        });
    }


});